export const FORM_TYPES = {
    SIGN_IN: 'signin',
    SIGN_UP: 'signup',
    EDIT_PROFILE: 'edit',
    FORGOT_PASSWORD: 'forgotPass',
    UPDATE_PASSWORD: 'updatePass'
};
